// this file added for individual by Bearer Web Developer
import React, { useMemo, useRef, useState } from "react";
import { Button } from "@mui/material";
import { Observer, observer } from "mobx-react-lite";
import styles from './confirm.module.scss'; // added by Bearer Web Developer
import { useAppState } from "../../../states/app-state";
import { StepForDeleteAccountEnum } from "../../../states/deleteAccountState";
import { validateCode } from "./validate";

const ConfirmDeleteAccount: React.FC = observer(() => {
    const appState = useAppState();
    const { deleteAccount } = appState;
    const handleClose = () => {
        deleteAccount.setStep(StepForDeleteAccountEnum.Request);
    }
    // const [error, setError] = React.useState('');
    const inputs = useRef<Array<HTMLInputElement | null>>([]);
    const code = inputs.current.map((input) => input?.value || "").join("");
    const [otp, setOtp] = useState(code); // otp is stand by One-Time Password
    const valid = useMemo(() => {
        return !validateCode(otp);
    }, [otp]);
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
        const value = e.target.value;
        // if (error) setError('');
        // only number and one number
        if (!/^\d?$/.test(value)) {
            // if it is not a nmuber remove it
            e.target.value = "";
            const code = inputs.current.map((input) => input?.value || "").join("");
            setOtp(code);
            return;
        } else {
            const code = inputs.current.map((input) => input?.value || "").join("");
            setOtp(code);
        }
        if (value && index < 5) {
            // go next
            inputs.current[index + 1]?.focus();
        }

        if (!value && index > 0) {
            // go back 
            inputs.current[index - 1]?.focus();
        }
    };
    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (valid) {
            try {
                // if (error) setError('');
                deleteAccount.setLoading(true);
                console.log({ otp });
                const result = await deleteAccount.customerConfirmDeleteAccount(otp);
                deleteAccount.setLoading(false);
                if (result) {
                    if (result.code === 200) {
                        appState.setSnackMessage({
                            message: result.message || '',
                            handleClick: async () => { await appState.login.logout(); },
                            hasLoadingForHandleClick: true
                        });
                    } else if (result.code === 400 || result.code === 423) {
                        if (result?.message) {
                            // setError(result?.message);
                            appState.setSnackMessage({ message: result.message });
                        }
                        else {
                            console.log(result);
                        }
                    } else {
                        console.log(result);
                    }
                }
            } catch (err: any) {
                deleteAccount.setLoading(false);
                if (err?.message) console.log(err?.message);
                console.log(err);
            }
        }
    }
    // modified by Bearer Web Developer start
    return (
        <section className={styles.confirm_delete_acount}>
            <header className={styles.header}>
                <h3>Delete Account</h3>
                <Button className={styles.back} disableRipple={true} onClick={handleClose}>
                    <img src="/back.png" alt="back" />
                </Button>
            </header>
            <h4>SMS Verification</h4>
            <p>Please enter the code sent to your registered phone number</p>
            <form onSubmit={handleSubmit}>
                <Observer>{() => (
                    <div className={styles.inputs}>
                        {
                            [...Array(6)].map((_, index) => (
                                <input
                                    key={index}
                                    type="tel"
                                    inputMode="numeric"
                                    maxLength={1}
                                    placeholder="---"
                                    className=""
                                    onChange={(e) => handleChange(e, index)}
                                    ref={(el) => {
                                        inputs.current[index] = el
                                    }}
                                />
                            ))
                        }
                    </div>
                )}</Observer>
                {/* {error && <div className={styles.error}>{error}</div>} */}
                <Observer>{() => {
                    return (
                        <>
                            <Button
                                type='submit'
                                className={styles.submit}
                                variant="text"
                                color="primary"
                                fullWidth
                                disabled={!valid}
                                disableRipple={true}
                            >
                                Delete My Account
                            </Button>
                        </>
                    )
                }}</Observer>
            </form>
        </section>
    );
    // modified by Bearer Web Developer end
})
export default ConfirmDeleteAccount;